/*
  Configurateur sachets (Tea Heritage custom).

  Module autonome : AUCUNE dépendance à theme.js (chargé derrière le hack
  UA-sniffing de js_files.liquid, non garanti).

  Preview : le design uploadé est collé automatiquement, centré, sur la carte
  étiquette kraft (CSS <img>) — vue « Sachet » (carte posée sur la photo) et
  vue « Étiquette » (3×3 cm avec règle).

  Fichiers clients : le block Uploadly (Uploadcare) uploade dès la sélection
  et écrit l'URL hébergée dans des inputs cachés properties[...]. Ce module
  lit ces URLs (poll 1 s) pour la preview de secours et pour joindre les
  fichiers à la demande de devis. Aucun ajout panier.

  Leads : le submit est intercepté et part vers l'Apps Script (settings
  gsheet_form_url / gsheet_form_map → Sheet + email), succès affiché sur
  place sans rechargement. Au succès, _trackLead émet GA4 generate_lead
  (gtag) + l'événement dataLayer « B2B lead » pour GTM-PRVZWZW (conteneur
  chargé sur cette seule page par layout/theme.liquid). Aucune donnée
  personnelle dans ces événements.
*/

window.theme = window.theme || {};

theme.SachetConfigurator = (function() {
  'use strict';

  var STASH_KEY = 'scfg-lead';
  var STASH_TTL_MS = 30 * 60 * 1000;
  var DRAWABLE_RE = /\.(png|jpe?g|webp|gif|svg)(\?.*)?$/i;
  var UNDRAWABLE_RE = /\.(pdf|ai|eps|psd|tiff?|zip|docx?)(\?.*)?$/i;
  var DRAWABLE_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg+xml'];

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

  // Klaviyo (popup roue) : son focus-trap vole le focus des champs du devis
  // (observé : focus() rappelé en boucle sur son bouton de fermeture, puis
  // blur() des inputs) — le formulaire devenait insaisissable. Sur cette page,
  // on neutralise ses prises de focus ; le teaser est masqué en CSS. Idéalement,
  // exclure aussi la page du ciblage du formulaire dans l'admin Klaviyo.
  function muzzleKlaviyoFocusTrap() {
    if (window.__scfgKlaviyoMuzzled) return;
    window.__scfgKlaviyoMuzzled = true;
    var origFocus = HTMLElement.prototype.focus;
    var origBlur = HTMLElement.prototype.blur;
    HTMLElement.prototype.focus = function() {
      if (this.closest && this.closest('[class*="klaviyo"], [class*="kl-teaser"], [class*="kl-private"]')) return;
      return origFocus.apply(this, arguments);
    };
    HTMLElement.prototype.blur = function() {
      // blur programmatique d'un champ du configurateur = Klaviyo ; les vrais
      // changements de focus utilisateur ne passent pas par element.blur()
      if (this.closest && this.closest('[data-scfg]')) return;
      return origBlur.apply(this, arguments);
    };
  }

  function SachetConfigurator(root) {
    this.root = root;
    muzzleKlaviyoFocusTrap();
    var configEl = root.querySelector('[data-scfg-config]');
    try {
      this.config = JSON.parse(configEl.textContent);
    } catch (err) {
      if (window.console && console.warn) console.warn('SachetConfigurator: config invalide', err);
      return;
    }

    this.form = root.querySelector('form.contact-form');
    this.photo = root.querySelector('[data-scfg-photo]');
    this.thumbPhoto = root.querySelector('[data-scfg-thumb-photo]');
    this.caption = root.querySelector('[data-scfg-caption]');
    this.msgEl = root.querySelector('[data-scfg-msg]');
    this.photoWrap = root.querySelector('[data-scfg-photo-wrap]');
    this.customPanel = root.querySelector('[data-scfg-custom-panel]');
    this.customNote = root.querySelector('[data-scfg-custom-note]');
    this.customLabel = root.querySelector('[data-scfg-custom-label]');
    this.priceBox = root.querySelector('[data-scfg-price]');
    this.priceHint = root.querySelector('[data-scfg-price-hint]');
    this.submitBtn = root.querySelector('[data-scfg-submit]');

    this.hostedFiles = {};   // { nom de champ Uploadly: URL hébergée }
    this.state = { designIsLocal: false, lastHostedUrl: null };

    this._bindEvents();
    this._pollTimer = setInterval(this._checkUploadlyProps.bind(this), 1000);

    // état initial depuis le DOM (radios checked)
    this._updateCustomLock();
    this._renderShape();
    this._updatePrice();
    this._dedupeSubmitButtons();

    this._fireTrackingIfPosted();
  }

  SachetConfigurator.prototype = {

    /* ---------------- état courant (lu depuis le DOM) ---------------- */

    _checked: function(name) {
      return this.root.querySelector('input[name="' + name + '"]:checked');
    },

    _lot: function() {
      var el = this._checked('scfg-lot');
      return el ? { qty: parseInt(el.value, 10), unit: parseFloat(el.dataset.unit) } : null;
    },

    _shape: function() {
      var el = this._checked('scfg-shape');
      return el ? { id: el.value, name: el.dataset.name, photo: el.dataset.photo } : null;
    },

    _identity: function() {
      var out = { complete: true };
      this.root.querySelectorAll('[data-scfg-identity]').forEach(function(input) {
        var key = input.type === 'email' ? 'email' :
          input.name.indexOf('Prénom') > -1 ? 'prenom' :
          input.name.indexOf('Nom') > -1 ? 'nom' : 'tel';
        out[key] = (input.value || '').trim();
        if (!out[key] || !input.checkValidity()) out.complete = false;
      });
      return out;
    },

    /* ---------------- events ---------------- */

    _bindEvents: function() {
      var self = this;

      this.root.addEventListener('change', function(e) {
        var t = e.target;
        if (t.matches('[data-scfg-lot]')) { self._updateCustomLock(); self._updatePrice(); }
        else if (t.matches('[data-scfg-shape]')) { self._renderShape(); }
        else if (t.matches('[data-scfg-cat]')) { self._filterShapes(t.value); }
      });

      this.root.addEventListener('input', function(e) {
        if (e.target.matches('[data-scfg-identity]')) self._updatePrice();
      });

      this.root.querySelectorAll('[data-scfg-view-btn]').forEach(function(btn) {
        btn.addEventListener('click', function() { self._switchView(btn.dataset.scfgViewBtn); });
      });

      // Sélection de fichier dans le widget/dialog Uploadcare (créé dynamiquement,
      // potentiellement hors de notre racine) : preview locale immédiate.
      document.addEventListener('change', this._onFileInputChange.bind(this), true);

      if (this.form) this.form.addEventListener('submit', this._onSubmit.bind(this));
    },

    /* ---------------- formes ---------------- */

    _filterShapes: function(cat) {
      var visible = 0;
      this.root.querySelectorAll('.scfg-shape:not(.scfg-shape--custom)').forEach(function(tile) {
        var show = cat === 'toutes' || tile.dataset.category === cat;
        tile.hidden = !show;
        if (show) visible++;
      });
      var count = this.root.querySelector('[data-scfg-shape-count]');
      if (count) count.textContent = visible + (visible > 1 ? ' formes' : ' forme');
      // si la forme sélectionnée vient d'être masquée, on prend la première visible
      var current = this._checked('scfg-shape');
      if (current && current.value !== 'custom' && current.closest('.scfg-shape').hidden) {
        var first = this.root.querySelector('.scfg-shape:not([hidden]) input[data-scfg-shape]:not([value="custom"])');
        if (first) { first.checked = true; this._renderShape(); }
      }
    },

    _updateCustomLock: function() {
      var lot = this._lot();
      var unlocked = lot && lot.qty >= this.config.customMinQty;
      var customInput = this.root.querySelector('input[value="custom"][data-scfg-shape]');
      var locknote = this.root.querySelector('[data-scfg-locknote]');
      var hint = this.root.querySelector('[data-scfg-custom-hint]');
      if (!customInput) return;
      customInput.disabled = !unlocked;
      if (this.customLabel) this.customLabel.classList.toggle('disabled', !unlocked);
      if (locknote) locknote.hidden = unlocked;
      if (hint) hint.hidden = unlocked;
      if (!unlocked && customInput.checked) {
        var fallback = this.root.querySelector('.scfg-shape:not([hidden]) input[data-scfg-shape]:not([value="custom"])');
        if (fallback) { fallback.checked = true; this._renderShape(); }
      }
    },

    _renderShape: function() {
      var shape = this._shape();
      if (!shape) return;
      var isCustom = shape.id === 'custom';
      // garde : un script tiers peut ré-activer l'input disabled — si "custom"
      // passe sous le minimum de pièces, on revient sur une forme standard
      var lot = this._lot();
      if (isCustom && lot && lot.qty < this.config.customMinQty) {
        var fallback = this.root.querySelector('.scfg-shape:not([hidden]) input[data-scfg-shape]:not([value="custom"])');
        if (fallback) { fallback.checked = true; this._renderShape(); }
        return;
      }
      if (this.photoWrap) this.photoWrap.hidden = isCustom;
      if (this.customPanel) this.customPanel.hidden = !isCustom;
      if (this.customNote) this.customNote.hidden = !isCustom;
      if (!isCustom && shape.photo) {
        if (this.photo && this.photo.getAttribute('src') !== shape.photo) {
          this.photo.src = shape.photo;
          this.photo.alt = 'Sachet ' + shape.name;
        }
        if (this.thumbPhoto) this.thumbPhoto.src = shape.photo;
      }
      if (this.caption) this.caption.textContent = isCustom ? 'Forme sur mesure' : 'Forme « ' + shape.name + ' »';
      this._switchView('sachet');
    },

    _switchView: function(view) {
      this.root.querySelectorAll('[data-scfg-view]').forEach(function(v) {
        v.hidden = v.dataset.scfgView !== view;
      });
      this.root.querySelectorAll('[data-scfg-view-btn]').forEach(function(btn) {
        var active = btn.dataset.scfgViewBtn === view;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    },

    /* ---------------- design → carte étiquette ---------------- */

    _setDesign: function(src, isLocal) {
      this.state.designIsLocal = isLocal;
      this.root.querySelectorAll('[data-scfg-tag-img]').forEach(function(img) {
        img.src = src;
        img.hidden = false;
      });
      this.root.querySelectorAll('[data-scfg-tag-placeholder]').forEach(function(el) { el.hidden = true; });
      if (this.msgEl) this.msgEl.hidden = true;
      var hint = this.root.querySelector('[data-scfg-upload-hint]');
      if (hint) hint.textContent = 'Votre design est collé sur l’étiquette dans l’aperçu.';
    },

    _clearDesign: function() {
      this.state.designIsLocal = false;
      this.root.querySelectorAll('[data-scfg-tag-img]').forEach(function(img) {
        img.hidden = true;
        img.removeAttribute('src');
      });
      this.root.querySelectorAll('[data-scfg-tag-placeholder]').forEach(function(el) { el.hidden = false; });
      if (this.msgEl) this.msgEl.hidden = true;
    },

    _setBadFormat: function() {
      this._clearDesign();
      if (this.msgEl) this.msgEl.hidden = false;
    },

    /* ---------------- fichiers (Uploadly) ---------------- */

    _onFileInputChange: function(e) {
      var input = e.target;
      if (!input || input.tagName !== 'INPUT' || input.type !== 'file') return;
      var file = input.files && input.files[0];
      if (!file) return;
      var drawable = DRAWABLE_TYPES.indexOf(file.type) > -1 || DRAWABLE_RE.test(file.name || '');
      if (!drawable) { this._setBadFormat(); return; }
      var self = this;
      var reader = new FileReader();
      reader.onload = function() { self._setDesign(reader.result, true); };
      reader.readAsDataURL(file);
    },

    _checkUploadlyProps: function() {
      // Uploadly prend le formulaire de devis pour un formulaire d'achat (il
      // ajoute ph_atc_btn au bouton) et désactive ses champs tant que son
      // upload « requis » est vide — or le fichier est optionnel pour un
      // devis : on ré-arme systématiquement, sauf pendant notre submit.
      if (!this._submitting) {
        this.root.querySelectorAll('[data-scfg-identity]').forEach(function(el) {
          if (el.disabled) el.disabled = false;
        });
        if (this.submitBtn) {
          if (this.submitBtn.disabled) this.submitBtn.disabled = false;
          if (this.submitBtn.style.display === 'none') this.submitBtn.style.display = '';
        }
      }
      this._dedupeSubmitButtons();
      var inputs = document.querySelectorAll('input[name^="properties["], textarea[name^="properties["]');
      var found = {};
      inputs.forEach(function(el) {
        var m = el.name.match(/^properties\[(.+)\]$/);
        var v = (el.value || '').trim();
        if (m && /^https?:\/\//.test(v)) found[m[1]] = v;
      });
      this.hostedFiles = found;

      var urls = Object.keys(found).map(function(k) { return found[k]; });
      var url = urls[0] || null;
      if (url) {
        if (url === this.state.lastHostedUrl) return;
        this.state.lastHostedUrl = url;
        if (this.state.designIsLocal) return; // preview locale déjà en place
        if (UNDRAWABLE_RE.test(url)) { this._setBadFormat(); return; }
        this._setDesign(url, false); // <img> : pas de contrainte CORS pour l'affichage
      } else if (this.state.lastHostedUrl) {
        // fichier retiré via l'UI Uploadly
        this.state.lastHostedUrl = null;
        if (!this.state.designIsLocal) this._clearDesign();
      }
    },

    // Uploadly clone le bouton d'envoi À L'IDENTIQUE (cloneNode profond :
    // classes ET data-scfg-submit copiés) et cache parfois l'original — aucun
    // sélecteur ne distingue les deux. On raisonne par IDENTITÉ DE NŒUD :
    // this.submitBtn est capturé à notre init, avant qu'Uploadly ne tourne,
    // c'est donc l'original. Chaque seconde : l'original est forcé visible,
    // tout autre bouton portant le même libellé est masqué. Si Uploadly a
    // détaché l'original du DOM, on adopte son remplaçant dans le form.
    _dedupeSubmitButtons: function() {
      if (this.submitBtn && !this.submitBtn.isConnected && this.form) {
        this.submitBtn = this.form.querySelector('[data-scfg-submit], button[type="submit"]');
      }
      if (!this.submitBtn) return;
      var original = this.submitBtn;
      var label = original.textContent.trim();
      if (!label) return;
      original.style.setProperty('display', 'inline-block', 'important');
      // le clone d'Uploadly est un DIV déguisé en bouton (ph_clone_atc_btn,
      // data-ph-cart-clone) — on ratisse boutons ET divs-boutons marqués
      document.querySelectorAll('button, [data-ph-cart-clone], .ph_clone_atc_btn').forEach(function(b) {
        if (b !== original && b.textContent.trim() === label) {
          b.style.setProperty('display', 'none', 'important');
        }
      });
    },

    _uploadInProgress: function() {
      return !!document.querySelector('.uploadcare--widget_status_started');
    },

    /* ---------------- prix ---------------- */

    _updatePrice: function() {
      var lot = this._lot();
      var identity = this._identity();
      if (!this.priceBox || !lot) return;
      var reveal = identity.complete;
      this.priceBox.hidden = !reveal;
      if (this.priceHint) this.priceHint.hidden = reveal;
      if (reveal) {
        this.root.querySelector('[data-scfg-price-total]').textContent = euro.format(lot.qty * lot.unit);
        this.root.querySelector('[data-scfg-price-unit]').textContent = lot.unit.toFixed(2).replace('.', ',');
        this.root.querySelector('[data-scfg-price-lot]').textContent = String(lot.qty);
      }
    },

    /* ---------------- submit ---------------- */

    _collect: function() {
      var lot = this._lot();
      var shape = this._shape();
      var parfumEl = this._checked('scfg-parfum');
      var files = this.hostedFiles;
      var fileLines = Object.keys(files).map(function(k) { return files[k]; });
      return {
        lot: lot ? String(lot.qty) : '',
        tarif: lot ? euro.format(lot.qty * lot.unit) + ' (' + lot.unit.toFixed(2).replace('.', ',') + ' € / sachet)' : '',
        parfum: parfumEl ? parfumEl.value : '',
        forme: shape ? (shape.id === 'custom' ? 'Sur mesure' : shape.name) : '',
        fichiers: fileLines.length ? fileLines.join(' | ') : 'aucun fichier uploadé — à demander par email si besoin'
      };
    },

    _syncHidden: function() {
      var data = this._collect();
      var identity = this._identity();
      var returnEl = this.root.querySelector('[data-scfg-return]');
      // pathname seul : Shopify rejette/dépouille les query strings du return_to
      if (returnEl) returnEl.value = window.location.pathname;
      this.root.querySelectorAll('[data-scfg-h]').forEach(function(el) {
        var key = el.dataset.scfgH;
        if (key === 'body') {
          el.value = [
            'Demande de devis — Configurateur sachets personnalisés',
            '',
            'Contact : ' + identity.prenom + ' ' + identity.nom + ' · ' + identity.tel + ' · ' + identity.email,
            'Quantité : ' + data.lot,
            'Parfum : ' + data.parfum,
            'Forme : ' + data.forme,
            'Tarif indicatif : ' + data.tarif,
            'Fichiers : ' + data.fichiers
          ].join('\n');
        } else if (data[key] !== undefined) {
          el.value = data[key];
        }
      });
    },

    _stash: function() {
      try {
        var identity = this._identity();
        var data = this._collect();
        var lot = this._lot();
        sessionStorage.setItem(STASH_KEY, JSON.stringify({
          ts: Date.now(),
          prenom: identity.prenom, nom: identity.nom, email: identity.email, tel: identity.tel,
          quantite: data.lot, parfum: data.parfum, forme: data.forme, tarif: data.tarif,
          fichiers: data.fichiers,
          value: lot ? lot.qty * lot.unit : 0
        }));
      } catch (err) { /* stockage indisponible : le tracking sautera, l'email part quand même */ }
    },

    // L'envoi ne passe PLUS par POST /contact : la protection anti-bot de
    // Shopify exigeait un aller-retour de vérification que ce thème casse
    // (hack document.write de js_files.liquid) — les envois mouraient sur
    // /?form_key=…&return_path=…. Tout part vers l'Apps Script (Sheet +
    // email via MailApp), succès affiché sur place, sans rechargement.
    _onSubmit: function(e) {
      e.preventDefault();
      if (this._sent || this._submitting) return; // un seul envoi par chargement
      if (!this.form.reportValidity()) return;
      var g = this.config.gsheet || {};
      if (!g.url) { // endpoint non configuré : rien d'autre à faire
        this._showError();
        return;
      }
      var self = this;
      this._submitting = true;
      if (this.submitBtn) this.submitBtn.classList.add('btn--loading');

      var deadline = Date.now() + (this.config.uploadTimeoutMs || 15000);
      (function waitUploads() {
        if (self._uploadInProgress() && Date.now() < deadline) {
          setTimeout(waitUploads, 400);
          return;
        }
        self._checkUploadlyProps();
        var identity = self._identity();
        var data = self._collect();
        var lead = {
          prenom: identity.prenom, nom: identity.nom, email: identity.email, tel: identity.tel,
          quantite: data.lot, parfum: data.parfum, forme: data.forme,
          tarif: data.tarif, fichiers: data.fichiers
        };
        var params = new URLSearchParams();
        Object.keys(lead).forEach(function(k) {
          params.append((g.map && g.map[k]) || k, lead[k]);
        });
        // UN SEUL canal d'envoi, jamais deux : sendBeacon d'abord (résultat
        // synchrone, insensible à la redirection 302 d'Apps Script), fetch
        // en repli uniquement si le beacon refuse la mise en file. Un fetch
        // livré puis rejeté sur la redirection suivi d'un beacon enverrait
        // le lead en double (emails et lignes Sheet dupliqués constatés).
        var queued = false;
        if (navigator.sendBeacon) {
          try {
            queued = navigator.sendBeacon(g.url,
              new Blob([params.toString()], { type: 'application/x-www-form-urlencoded' }));
          } catch (err) { queued = false; }
        }
        if (queued) {
          self._showSuccess(lead);
        } else {
          fetch(g.url, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
          }).then(function() { self._showSuccess(lead); })
            .catch(function() { self._showError(); });
        }
      })();
    },

    _showSuccess: function(lead) {
      this._sent = true; // verrou définitif : Uploadly re-déclenche parfois le submit
      if (this.submitBtn) this.submitBtn.classList.remove('btn--loading');
      var note = document.createElement('p');
      note.className = 'note note--success';
      note.setAttribute('data-scfg-posted', '');
      note.textContent = 'Merci ! Votre demande de devis est bien envoyée — l’atelier vous répond sous 2 jours ouvrés avec votre devis et votre BAT.';
      this.form.parentNode.insertBefore(note, this.form);
      this.form.hidden = true;
      note.scrollIntoView({ block: 'center' });
      var lot = this._lot();
      this._trackLead(lead, lot ? lot.qty * lot.unit : 0);
    },

    _showError: function() {
      this._submitting = false;
      if (this.submitBtn) this.submitBtn.classList.remove('btn--loading');
      var existing = this.root.querySelector('[data-scfg-send-error]');
      if (existing) return;
      var note = document.createElement('p');
      note.className = 'errors';
      note.setAttribute('data-scfg-send-error', '');
      note.textContent = 'L’envoi a échoué — réessayez, ou écrivez-nous directement par email.';
      this.form.parentNode.insertBefore(note, this.form);
    },

    /* ---------------- tracking post-succès (GA4 + dataLayer GTM + Google Sheet) ---------------- */

    // Point d'émission unique des conversions, pour les deux chemins de succès
    // (_showSuccess, _fireTrackingIfPosted). « B2B lead » = déclencheur
    // « Événement personnalisé » dans GTM-PRVZWZW : nom exact, casse comprise.
    _trackLead: function(lead, value) {
      var params = {
        currency: 'EUR', value: value,
        forme: lead.forme, quantite: lead.quantite, parfum: lead.parfum
      };
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: 'B2B lead' }, params));
      } catch (err) { /* sans conséquence */ }
      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', params);
      } catch (err) { /* gtag absent/bloqué : sans conséquence */ }
    },

    _sendToSheet: function(lead) {
      var g = this.config.gsheet || {};
      if (!g.url || !g.map) return;
      try {
        var params = new URLSearchParams();
        Object.keys(g.map).forEach(function(key) {
          if (g.map[key] && lead[key] !== undefined) params.append(g.map[key], lead[key]);
        });
        var sent = false;
        if (navigator.sendBeacon) {
          var blob = new Blob([params.toString()], { type: 'application/x-www-form-urlencoded' });
          sent = navigator.sendBeacon(g.url, blob);
        }
        if (!sent) {
          fetch(g.url, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: params.toString()
          });
        }
      } catch (err) { /* fire-and-forget */ }
    },

    _fireTrackingIfPosted: function() {
      var posted = this.root.querySelector('[data-scfg-posted]') ||
        /contact_posted=true/.test(window.location.search);
      if (!posted) return;
      var raw = null;
      try { raw = sessionStorage.getItem(STASH_KEY); } catch (err) { /* ignore */ }
      if (raw) {
        try {
          var lead = JSON.parse(raw);
          if (Date.now() - lead.ts < STASH_TTL_MS) {
            this._sendToSheet(lead);
            this._trackLead(lead, lead.value || 0);
          }
        } catch (err) { /* stash illisible */ }
        try { sessionStorage.removeItem(STASH_KEY); } catch (err) { /* ignore */ }
      }
      var note = this.root.querySelector('[data-scfg-posted]');
      if (note && note.scrollIntoView) note.scrollIntoView({ block: 'center' });
    }
  };

  function init() {
    document.querySelectorAll('[data-scfg]').forEach(function(el) {
      if (el.dataset.scfgInit) return;
      el.dataset.scfgInit = '1';
      new SachetConfigurator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('page:loaded', init);

  return { init: init };
})();
